/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react-hooks/exhaustive-deps */
// app/components/Testimonials.tsx
"use client";

import { useState, useRef, useEffect } from "react";
import { motion, useInView, AnimatePresence } from "framer-motion";

const GREEN = "rgb(34 150 83)";

type Testimonial = {
  id: number;
  name: string;
  rating: number;
  text: string;
  treatment: string;
};

const TESTIMONIALS: Testimonial[] = [
  {
    id: 1,
    name: "Nitish A Nayaka",
    rating: 5,
    text:
      "Great experience at pinak dental clinic got my root canal treatment done the entire procedure was painless . The treatment plan and execution of the treatment was very nice done by the doctor and his team.",
    treatment: "Root Canal Treatment",
  },
  {
    id: 2,
    name: "Ajinkya Shukla",
    rating: 5,
    text:
      "I recently visited Pinak dental clinic for cleaning and bleaching of my teeth .From the initial consultation to the final procedure, the entire experience was professional, comfortable, and personalized. The dentist recommended the best options for my smile. The results look natural and I was amused. The office is modern, clean, and the staff is welcoming. I highly recommend Pinak dental clinic to anyone considering cosmetic dental treatment.",
    treatment: "Teeth Cleaning & Whitening",
  },
  {
    id: 3,
    name: "Amal",
    rating: 5,
    text:
      "I visited Pinak Dental Clinic for a tooth problem and was treated by Dr. Ayush. He was highly efficient and provided excellent treatment. I was impressed with the clinic's hygiene and use of latest technology. I highly recommend Pinak Dental Clinic for any dental problems, as they offer quality care at affordable prices.",
    treatment: "General Dentistry",
  },
  {
    id: 4,
    name: "Yamuna Ravindran",
    rating: 5,
    text:
      "Got my teeth bleaching treatment done here by Dr Abhijit Mukherjee. Very knowledgeable and passionate doctor who performed the procedure really well. Well maintained hygienic clinic with a great team and affordable prices.",
    treatment: "Teeth Bleaching",
  },
  {
    id: 5,
    name: "Shamshad Begum",
    rating: 5,
    text:
      "Visited pinak dental clinic with severe pain. Re RCT done by Dr Ayush and Dr Shifa and the pain was relieved quickly. Excellent care .",
    treatment: "Root Canal Treatment",
  },
];

export default function Testimonials() {
  const rootRef = useRef<HTMLDivElement>(null);
  const inView = useInView(rootRef, { once: true, margin: "-10%" });

  const [activeIndex, setActiveIndex] = useState(0);

  const next = () =>
    setActiveIndex((prev) => (prev + 1) % TESTIMONIALS.length);
  const prev = () =>
    setActiveIndex(
      (prev) => (prev - 1 + TESTIMONIALS.length) % TESTIMONIALS.length
    );

  useEffect(() => {
    const interval = setInterval(next, 5000);
    return () => clearInterval(interval);
  }, [activeIndex]);

  return (
    <section
      id="testimonials"
      ref={rootRef}
      className="relative overflow-hidden bg-gradient-to-b from-white via-gray-50 to-white py-16 sm:py-20 lg:py-24"
    >
      <div className="relative z-10 mx-auto max-w-7xl px-4 sm:px-6 lg:px-12">
        {/* ===== HEADER ===== */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="mb-12 sm:mb-16 text-center"
        >
          <span className="inline-block rounded-full border-2 border-emerald-300 bg-emerald-100 px-6 py-2 text-sm font-bold text-emerald-700">
            💬 Patient Stories
          </span>

          <h2 className="mt-6 text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-black text-gray-900">
            Real Stories, Real Smiles
            {" "}

          </h2>

          <p className="mx-auto mt-4 max-w-2xl text-base sm:text-lg text-gray-600">
Discover genuine 5-star reviews from happy patients who trust us for exceptional dental care and healthy smiles.          </p>
        </motion.div>

        {/* ===== SLIDER ===== */}
        <div className="relative mx-auto max-w-4xl">
          <div className="relative h-[360px] sm:h-[420px] lg:h-[480px]">
            <AnimatePresence mode="wait">
              <motion.div
                key={activeIndex}
                initial={{ opacity: 0, y: 40, scale: 0.96 }}
                animate={{ opacity: 1, y: 0, scale: 1 }}
                exit={{ opacity: 0, y: -40, scale: 0.96 }}
                transition={{ duration: 0.4 }}
                className="absolute inset-0"
              >
                <div
                  className="overflow-hidden border-2 bg-white shadow-2xl"
                  style={{
                    borderColor: GREEN,
                    boxShadow: `0 25px 60px ${GREEN}30`,
                  }}
                >
                  <div className="p-5 sm:p-7 lg:p-10">
                    {/* Rating */}
                    <div className="mb-4 sm:mb-6 flex gap-1">
                      {[...Array(TESTIMONIALS[activeIndex].rating)].map(
                        (_, i) => (
                          <span key={i} className="text-xl sm:text-2xl">
                            ⭐
                          </span>
                        )
                      )}
                    </div>

                    {/* Quote */}
                    <p className="text-base sm:text-lg lg:text-2xl italic leading-relaxed text-gray-700">
                      &ldquo;{TESTIMONIALS[activeIndex].text}&rdquo;
                    </p>

                    {/* Author */}
                    <div className="mt-6 sm:mt-8 flex items-center gap-4 sm:gap-6">
                      <div>
                        <h4 className="text-lg sm:text-xl font-bold text-gray-900">
                          {TESTIMONIALS[activeIndex].name}
                        </h4>

                        <div className="mt-2 inline-block rounded-full border border-emerald-300 bg-emerald-100 px-3 py-1 text-xs font-semibold text-emerald-700">
                          {TESTIMONIALS[activeIndex].treatment}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Decorative corner */}
                  <div className="absolute right-0 top-0 size-32 overflow-hidden hidden sm:block">
                    <div className="absolute -right-16 -top-16 size-32 rounded-full bg-gradient-to-br from-emerald-400 to-emerald-600 opacity-20" />
                  </div>
                </div>
              </motion.div>
            </AnimatePresence>
          </div>

          {/* ===== CONTROLS ===== */}
          <div className="mt-6 flex justify-center gap-4">
            <motion.button
              onClick={prev}
              className="grid size-12 sm:size-14 place-items-center rounded-full border-2 border-emerald-500 bg-white text-xl sm:text-2xl text-emerald-600 shadow-lg"
              whileHover={{ scale: 1.1, backgroundColor: GREEN, color: "#fff" }}
              whileTap={{ scale: 0.95 }}
            >
              ←
            </motion.button>

            <motion.button
              onClick={next}
              className="grid size-12 sm:size-14 place-items-center rounded-full border-2 border-emerald-500 bg-white text-xl sm:text-2xl text-emerald-600 shadow-lg"
              whileHover={{ scale: 1.1, backgroundColor: GREEN, color: "#fff" }}
              whileTap={{ scale: 0.95 }}
            >
              →
            </motion.button>
          </div>

          {/* ===== PAGINATION ===== */}
          <div className="mt-6 flex justify-center gap-2">
            {TESTIMONIALS.map((_, i) => (
              <button
                key={i}
                onClick={() => setActiveIndex(i)}
                className="rounded-full transition-all"
                style={{
                  backgroundColor: i === activeIndex ? GREEN : "#d1d5db",
                  width: i === activeIndex ? "28px" : "10px",
                  height: "10px",
                }}
                aria-label={`Go to testimonial ${i + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
